<template>
    <el-dialog title="添加心仪职业" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-identify">
        <img src="../assets/images/close.png" alt="关闭" @click="closeHandler">
        <div class="search-img header-search">
            <el-input placeholder="搜索职业名称" v-model="search.job_name" clearable @keyup.enter.native="getJobListHandler">
                <template slot="append">
                    <img src="@/assets/images/sousuo.png" alt="搜索" @click="getJobListHandler">
                </template>
            </el-input>
        </div>
        <div class="level-view2">
            <div v-for="(item, key) in job_level_list1" :key="key" :class="job_active_level1 == key?'active-level2':''" @click="changeJobLevel1(key)">
                {{ item.job_name }}
            </div>
        </div>
        <el-row>
            <el-col :span="6">
                <el-scrollbar wrap-class="vertical_scrollbar">
                    <a @click="changeJobLevel2('#level' + item.job_code, key)" v-for="(item, key) in job_level_list2" :key="key" :class="['item-view', job_active_level2 === key ? 'acitve-item' : '']">
                        {{ item.job_name }}
                    </a>
                </el-scrollbar>
            </el-col>
            <el-col :span="18">
                <el-scrollbar v-show="job_total > 0" wrap-class="vertical_scrollbar" id="scrollView" ref="scroll">
                    <div :id="'level' + item.job_code" v-for="(item, key) in job_level_list2" :key="key">
                        <div class="provice-view">{{ item.job_name }}</div>
                        <div v-for="(item1, key1) in item.children" :key="key1" class="item-view" @click="selectJob(item1)">
                            {{ item1.job_name }}
                            <img v-if="!item1.checked" src="@/assets/images/select_icon1.png">
                            <img v-else src="@/assets/images/select_icon2.png">
                        </div>
                    </div>
                </el-scrollbar>
                <div v-if="job_total === 0" class="no-data-box">
                    <img src="@/assets/images/null.png" alt="没有数据">
                    <p>暂无职业信息</p>
                </div>
            </el-col>
        </el-row>
        <div class="flex">
            <el-popover
                placement="top"
                popper-class="popper-view"
                trigger="click"
                :visible-arrow="false"
                @hide="show_data=false"
            >
                <el-table :data="select_job">
                    <el-table-column prop="job_name" min-width="200"></el-table-column>
                    <el-table-column width="100" align="right">
                        <template slot-scope="scope">
                            <div class="remove-btn" @click="removeJob(scope.row, scope.$index)">移除</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="add-count" slot="reference" @click="show_data=!show_data">已添加：<span>{{ select_job.length }}</span>/5<i v-if="!show_data" class="el-icon-arrow-down"></i><i v-else class="el-icon-arrow-up"></i></div>
            </el-popover>
            <div>
                <el-button @click="closeHandler">取消</el-button>
                <el-button class="save-btn" @click="addJob">保存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getJobList, getJobCategory } from '@/api/occupation'
export default {
    name: 'IntentionJob',
    props: ['jobList'],
    data() {
        return {
            search: {
                job_name: '',
            },
            click_status: false,
            select_job: [],
            show_data: false,
            job_level_list1: [],
            job_active_level1: 0,
            job_active_level2: 0,
            job_active_level3: 0,
            job_level_list2: [],
            job_level_list3: [],
            job_total: -1,
            top_list: []
        }
    },
    mounted() {
        this.select_job = [...this.jobList]
        this.getAlljobHandler()
    },
    methods: {
        closeHandler() {
            this.$store.commit('user/SHOWINTENTIONJOB', false)
        },
        getAlljobHandler() {
            getJobCategory().then((res) => {
                res.data.map(item => {
                    this.job_level_list1.push(item)
                })
                this.getJobListHandler()
            })
        },
        searchJobListHandler() {
            this.job_active_level2 = 0
            this.getJobListHandler()
        },
        getJobListHandler() {
            const that = this
            let job_code = this.job_level_list1[this.job_active_level1].job_code
            getJobList(this.search.job_name, job_code).then((res) => {
                let data = res.data.list
                this.job_total = data.length
                data.map((item, index) => {
                    item.children.map(item1 => {
                        item1.children.map(item2 => {
                            const index_tmp = this.select_job.findIndex(val => { 
                                return val.job_code === item2.job_code 
                            })
                            if(index_tmp > -1) {
                                item2.checked = true
                            } else {
                                item2.checked = false
                            }
                            item2.index = item1.job_code
                        })
                        this.job_level_list2.push(item1)
                    })
                })
                this.job_level_list2.map((item) => {
                    that.$nextTick(()=> {
                        const div = 'level' + item.job_code
                        const tmp = {
                            top: document.getElementById(div).offsetTop
                        }
                        that.top_list.push(tmp)
                    })
                })
                document.getElementById('scrollView').addEventListener('scroll', that.scrollView, true)
            })
        },
        // 改变一级职业
        changeJobLevel1(index) {
            const that = this
            this.job_active_level1 = index
            this.job_active_level2 = 0
            this.job_level_list2 = []
            this.top_list = []
            this.$refs.scroll.$refs.wrap.scrollTop = 0
            this.getJobListHandler()
        },
        // 改变二级职业
        changeJobLevel2(div, key) {
            const that = this
            that.click_status = true
            document.getElementById('scrollView').removeEventListener('scroll', that.scrollView)
            that.job_active_level2 = key
            window.location.href = div
            setTimeout(() => {
                that.click_status = false
            }, 100)
        },
        // 滚动
        scrollView() {
            if(this.click_status) {
                return
            }
            let top = this.$refs.scroll.$refs.wrap.scrollTop
            this.top_list.map((item, index) => {
                if(top >= item.top) {
                    this.job_active_level2 = index
                    return
                }
            })
            
        },
        // 选择职业
        selectJob(data) {
            const index_tmp = this.select_job.findIndex(val => { return val.job_code === data.job_code })
            if(index_tmp === -1) {
                if(this.select_job.length > 4) {
                    return
                }
                data.checked = true
                this.select_job.push(data)
            } else {
                data.checked = false
                this.select_job.splice(index_tmp, 1)
            }
        },
        // 职业提交
        addJob() {
            this.$emit('update', this.select_job)
            this.closeHandler()
        },
        // 移除职业
        removeJob(data, index) {
            const index_tmp = this.job_level_list2.findIndex(val => { return val.job_code === data.job_parent_code })
            if(index_tmp > -1) {
                const job_tmp = this.job_level_list2[index_tmp]
                const job_index_tmp = job_tmp.children.findIndex(val => { return val.job_code === data.job_code })
                if(job_index_tmp > -1) {
                    job_tmp.children[job_index_tmp].checked = false
                }
            }
            this.select_job.splice(index, 1)
        }
    }
}
</script>

<style lang='scss' scoped>
@import "@/assets/css/variables.scss";
.dialog-box {
    ::v-deep .el-dialog {
        height: 600px;
        width: 720px;
        .vertical_scrollbar {
            overflow-x: hidden;
            height: 300px;
            min-height: 300px;
            padding-bottom: 20px;
        }
        .el-button {
            width: 100px!important;
            height: 44px!important;
            background: #ffffff!important;
            border: 1px solid #c4c7cc!important;
            border-radius: 8px;
            color: #5e6166!important;
            font-size: 16px;
        }
        .save-btn {
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            border: none!important;
            color: #ffffff!important;
        }
    }
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    .el-col-6 {
        padding-right: 18px;
        border-right: 1px solid #e1e4eb;
    }
    .item-view {
        padding: 12px 0;
        border-bottom: 1px solid #e1e4eb;
        font-size: 14px;
        color: #5e6166;
        line-height: 20px;
        cursor: default;
        display: block;
        text-decoration: none;
        position: relative;
    }
    .acitve-item {
        color: #ff6524;
    }
    .provice-view {
        color: #999390;
        margin-top: 12px;
    }
    .el-col-18 {
        padding-left: 16px;
        .item-view {
            color: #2c2e33;
            padding: 12px 0;
            img {
                position: absolute;
                right: 0;
                top: 15px;
                width: 20px;
                height: 20px;
            }
        }
    }
    .flex {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .add-count {
            font-size: 14px;
            span {
                color: #ff6524;
            }
        }
    }
}
.remove-btn {
    color: #ff6524;
    cursor: pointer;
}
.el-icon-arrow-down {
    color: #c4c7cc;
    font-size: 14px;
    margin-left: 6px;
    position: relative;
    top: 2px;
}
.el-icon-arrow-up {
    color: #ff6524;
    font-size: 14px;
    margin-left: 6px;
    position: relative;
}
::v-deep .header-search {
    position: relative;
    z-index: 1000;
    .el-input__inner {
        padding: 0 16px;
    }
    .el-input-group__append {
        img {
            position: absolute;
            top: 10px;
            right: 16px;
        }
    }
}
.level-view1 {
    flex: 0 0 114px;
    height: 44px;
    line-height: 32px;
    background: #ffffff;
    border: 1px solid #e1e4eb;
    border-radius: 8px;
    margin-right: 16px;
    color: #5e6166;
    font-size: 16px;
    padding: 4px 5px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    .active-level1 {
        background: #ff6524;
        border-radius: 4px;
        color: #ffffff;
    }
    span {
        margin: 0 4px;
        width: 52px;
        height: 34px;
        text-align: center;
    }
}
.level-view2 {
    display: flex;
    flex-wrap: wrap;
    margin: 16px 0;
    div {
        font-size: 14px;
        color: #5e6166;
        padding: 4px;
        cursor: pointer;
    }
    div:not(:last-child) {
        margin-right: 24px;
    }
    .active-level2 {
        background: #ff6524;
        border-radius: 4px;
        color: #ffffff;
    }
    
}
.more-view {
    color: #ff6524!important;
}
.level-item {
    text-align: center;
}
.level-item:not(:last-child) {
    margin-bottom: 12px;
}
.no-data-box {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 67%;
    transform: translate(-50%, -50%);
    img {
        width: 110px!important;
        height: 110px!important;
        position: relative;
        top: 0;
        right: auto;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
    }
}
</style>